import React from 'react';

import type { WidgetFC } from '@swf/core/types/Widget';

import SundayMillion from './components/SundayMillion/SundayMillion';
import { pokerSundayMillionWidgetModel } from './model';
import './PokerSundayMillionWidget.scss';

const PokerSundayMillionsWidget: WidgetFC = () => <SundayMillion />;

PokerSundayMillionsWidget.model = pokerSundayMillionWidgetModel;

export default PokerSundayMillionsWidget;
